<main class="auth-page">
  <div class="top-row">
    <button type="button" class="back-btn" [attr.aria-label]="'auth.common.backAria' | translate" (click)="goBack()">
      <sz-icon name="arrow-back" [size]="20" />
    </button>
    <sz-brand-block [compact]="true" />
  </div>

  <auth-spectrum-accent />

  <div class="auth-head">
    <div class="auth-head__kicker">
      <span>{{ 'auth.resetSent.kicker' | translate }}</span>
    </div>
    <h1 class="auth-head__title">
      {{ 'auth.resetSent.titleMain' | translate }}
      <span class="auth-head__accent">{{ 'auth.resetSent.titleAccent' | translate }}</span>
    </h1>
    <p class="auth-head__lead">
      {{ 'auth.resetSent.leadPrefix' | translate }} <b>{{ email() }}</b
      >{{ 'auth.resetSent.leadSuffix' | translate }}
    </p>
  </div>

  <ul class="bullet-list">
    <li class="bullet-list__row">
      <span class="bullet-list__icon" aria-hidden="true">
        <sz-icon name="check" [size]="14" />
      </span>
      <span>{{ 'auth.resetSent.bullet1' | translate }}</span>
    </li>
    <li class="bullet-list__row">
      <span class="bullet-list__icon" aria-hidden="true">
        <sz-icon name="check" [size]="14" />
      </span>
      <span>{{ 'auth.resetSent.bullet2' | translate }}</span>
    </li>
    <li class="bullet-list__row">
      <span class="bullet-list__icon" aria-hidden="true">
        <sz-icon name="check" [size]="14" />
      </span>
      <span>{{ 'auth.resetSent.bullet3' | translate }}</span>
    </li>
  </ul>

  @if (errorMessage(); as msg) {
    <p class="auth-error" role="alert">{{ msg }}</p>
  }

  <button type="button" class="cta cta--secondary" [disabled]="countdown() > 0 || resending()" (click)="onResend()">
    @if (countdown() > 0) {
      {{ 'auth.resetSent.resendCountdown' | translate: { seconds: countdown() } }}
    } @else if (resending()) {
      {{ 'auth.resetSent.resendSending' | translate }}
    } @else {
      {{ 'auth.resetSent.resendCta' | translate }}
    }
  </button>

  <p class="alt">
    <a [routerLink]="loginPath">{{ 'auth.resetSent.altLink' | translate }}</a>
  </p>
</main>
